import { CHARACTER_LIMIT_DESKTOP, CHARACTER_LIMIT_TABLET, CHARACTER_LIMIT_MOBILE } from './constants';

export default (function () {

    let elementsToTrim = document.querySelectorAll('.trim > p');
    if (elementsToTrim) {
        Array.prototype.slice.call(elementsToTrim).forEach((textElementToTrim, i) => {
            inlineTrim(textElementToTrim, i);
        });
    }
})();

function inlineTrim(el: HTMLElement, id: number) {
    let fullString: string = el.innerHTML,
        split = [],
        marker: number,
        checkboxId: string,
        characterLimit = getCharacterLimit(),
        buffer = getBuffer()

    if (fullString.length > (characterLimit + buffer)) {
        marker = Math.min(characterLimit, fullString.substr(0, characterLimit).lastIndexOf(" "));
        split = [fullString.substr(0, marker), fullString.substr(marker)];
        checkboxId = "readMore" + id;
        el.innerHTML = `<span>${split[0]}</span>
                            <input type="checkbox" id="${checkboxId}">
                            <label for="${checkboxId}"></label>
                            <span>${split[1]}</span>
                            <label for="${checkboxId}"></label>`;
    }
    else {
        el.innerHTML = fullString;
    }
}

function getCharacterLimit() {    
    if (window.innerWidth > 1024) {
        return CHARACTER_LIMIT_DESKTOP;
    }
    if (window.innerWidth < 1024 && window.innerWidth > 400) {
        return CHARACTER_LIMIT_TABLET;
    }
    if (window.innerWidth < 400) {
        return CHARACTER_LIMIT_MOBILE;
    }
}

function getBuffer() {
    if (window.innerWidth > 1024) {
        return 50;
    }
    if (window.innerWidth < 1024 && window.innerWidth > 400) {
        return 25;
    }
    if (window.innerWidth < 400) {
        return 10;
    }
}